import React, { Component } from "react";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import EditFaseDialog from "../../components/structure/EditFaseDialog";

class EditFaseContainer extends Component {
  state = {
    name: "",
    description: "",
    scoreType: "default",
    scoreTypeChanged: false,
    open: false,
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ open: !this.state.open });
      if (!this.state.open) {
        // reset state on closing dialog
        const fase = this.props.faseObject;
        if (fase) {
          this.updateState(fase);
        }
      }
    }
  };

  UNSAFE_componentWillMount = () => {
    const fase = this.props.faseObject;
    if (fase) {
      this.updateState(fase);
    }
  };

  updateState = (fase) => {
    this.setState({
      name: fase.name || "",
      description: fase.description || "",
      scoreType: fase.scoreType || "default",
      scoreTypeChanged: false,
    });
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    if (event.target.name === "scoreType") {
      newState["scoreTypeChanged"] = true;
    }
    this.setState(newState);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const db = window.firebase.firestore();
    const batch = db.batch();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    const divisionRef = tournamentRef
      .collection("divisions")
      .doc(this.props.division.id);

    let newFase = {
      name: this.state.name,
      description: this.state.description,
      scoreType: this.state.scoreType,
      started: this.props.faseObject.started,
    };
    const faseId = this.props.fase;
    let newFases = this.props.division.fases || [
      { name: languages.structure.fase + " 1", started: true },
    ];
    newFases[faseId] = newFase;

    batch.update(divisionRef, { fases: newFases });

    let scoringTypesPerDivisionPerPhase =
      this.props.tournament.scoringTypesPerDivisionPerPhase || {};
    if (scoringTypesPerDivisionPerPhase[this.props.division.id] === undefined) {
      scoringTypesPerDivisionPerPhase[this.props.division.id] = {};
    }
    scoringTypesPerDivisionPerPhase[this.props.division.id][faseId] =
      this.state.scoreType;
    batch.update(tournamentRef, {
      scoringTypesPerDivisionPerPhase: scoringTypesPerDivisionPerPhase,
    });

    if (this.state.scoreTypeChanged) {
      let allStructureObjects = this.props.structureObjects || [];
      (this.props.allBracketsForPhase || []).forEach((b) => {
        if (b.subBracketTo) {
          allStructureObjects.push(b);
        }
      });
      if (allStructureObjects.length > 0) {
        this.props.structureObjects.forEach((s) => {
          if (s.pouleSize) {
            //poule
            batch.update(tournamentRef.collection("poules").doc(s.id), {
              scoreType: this.state.scoreType,
            });
          } else {
            // bracket
            let scoringTypesPerBracket =
              this.props.tournament.scoringTypesPerBracket || {};
            scoringTypesPerBracket[s.id] = this.state.scoreType;
            batch.update(
              db.collection("tournaments").doc(this.props.tournament[".key"]),
              {
                scoringTypesPerBracket: scoringTypesPerBracket,
              }
            );
            batch.update(tournamentRef.collection("brackets").doc(s.id), {
              scoreType: this.state.scoreType,
            });
            (this.props.poules || [])
              .filter((p) => p.bracket === s.id)
              .forEach((p) => {
                batch.update(tournamentRef.collection("poules").doc(p.id), {
                  scoreType: this.state.scoreType,
                });
              });
          }
        });
      }
    }

    batch.commit().then(() => {
      this.toggleDialog();
      this.setState({ scoreTypeChanged: false });
    });
  };

  handleAdd = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      const divisionRef = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("divisions")
        .doc(this.props.division.id);

      let newFases = this.props.division.fases || [
        { name: languages.structure.fase + " 1", started: true },
      ];

      newFases.push({
        name: languages.structure.fase + " " + (newFases.length + 1).toString(),
        started: false,
      });

      divisionRef.update({ fases: newFases });
    }
  };

  render() {
    let scoreType = this.state.scoreType;
    if (scoreType !== "default") {
      if ((this.props.tournament.scoringTypes || {})[scoreType] === undefined) {
        scoreType = "default";
      }
    }
    let numChildScoreTypes = 1;
    let allStructureObjects = this.props.structureObjects || [];
    (this.props.allBracketsForPhase || []).forEach((b) => {
      if (b.subBracketTo) {
        allStructureObjects.push(b);
      }
    });
    if (allStructureObjects.length > 0) {
      (this.props.structureObjects || []).forEach((s) => {
        let scoreT = s.scoreType;
        if (scoreT !== "default") {
          if (
            (this.props.tournament.scoringTypes || {})[scoreT] === undefined
          ) {
            scoreT = "default";
          }
        }
        if (scoreT && scoreT !== scoreType) {
          numChildScoreTypes++;
        }
        if (!s.pouleSize) {
          // bracket: check for different scoreType in poules for bracket
          this.props.poules
            .filter((p) => p.bracket === s.id)
            .forEach((p) => {
              let scoreTPoule = p.scoreType;
              if (scoreTPoule !== "default") {
                if (
                  (this.props.tournament.scoringTypes || {})[scoreTPoule] ===
                  undefined
                ) {
                  scoreTPoule = "default";
                }
              }
              if (scoreTPoule && scoreTPoule !== scoreType) {
                numChildScoreTypes++;
              }
            });
        }
      });
    }
    if (numChildScoreTypes > 1 && !this.state.scoreTypeChanged) {
      scoreType = "multiple";
    }
    return (
      <div>
        {this.props.faseObject ? (
          <IconButton
            aria-label="Change"
            onClick={this.toggleDialog}
            style={{ height: 20, width: 20, marginLeft: 5 }}
          >
            <CreateIcon
              style={{ height: 20, width: 20, position: "absolute", top: 2 }}
            />
          </IconButton>
        ) : (
          <Button
            variant="outlined"
            color="default"
            onClick={this.handleAdd}
            size="small"
          >
            {languages.structure.addFase}
          </Button>
        )}
        <EditFaseDialog
          name={this.state.name}
          description={this.state.description}
          scoreType={scoreType}
          showMultiple={numChildScoreTypes > 1 && !this.state.scoreTypeChanged}
          open={this.state.open}
          faseObject={this.props.faseObject}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          tournament={this.props.tournament}
        />
      </div>
    );
  }
}

export default EditFaseContainer;
